import {Button, ComponentClassName} from "@dp-instant/ui";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {playUIClickSound} from "@game/helpers";
import {ISocial} from "@dp-instant/social";
import {TypesSocial} from "@dp-instant/interfaces";
import {useInjection} from "@dp-instant/ui";
import {Action} from "@dp-instant/core";
import {TypesGame} from "@game/TypesGame";
import {lazyGet} from "@dp-instant/core";

export const LeaderboardButton = (props: IClickableComponentProps & ComponentClassName) => {
    const social: ISocial & {userAuthorized?: boolean; authorizeUser?: () => Promise<boolean>} =
        useInjection(TypesSocial.model);

    return (
        <Button
            className={cn("btn-blue", "leaderboard-button", props.className)}
            icon="leaderboard"
            onClick={async () => {
                if (props.onClick) {
                    playUIClickSound();

                    let isUserAuhorized =
                        social.userAuthorized !== undefined && social.authorizeUser !== undefined
                            ? social.userAuthorized
                            : true;
                    if (!isUserAuhorized) {
                        isUserAuhorized = await lazyGet<Action<boolean>>(
                            TypesGame.actions.suggestAuthorizeAction
                        )?.run();

                        if (isUserAuhorized) {
                            await lazyGet<Action>(
                                TypesGame.actions.syncYandexLeaderboardsAction
                            )?.run();
                        }
                    }

                    if (isUserAuhorized) {
                        props.onClick();
                    }
                }
            }}
        ></Button>
    );
};
